var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full gradient-bg flex flex-col align-center pl-5 pr-4"},[_c('div',{staticClass:"mt-15"},[_c('WestoreLogo')],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }